import {ApexOptions} from "apexcharts";
import dynamic from "next/dynamic";
import {useEffect, useState} from "react";
const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});

interface ChartSeries {
  name: string;
  data: number[];
}
type values = {
  date: number;
  breachCount: number;
}[];
export default function NokiaSuddenAccelerationChart({
  valuesSuddenAcc
}: {
  valuesSuddenAcc: values;
}) {
  const [suddenAccelerationChart, setSuddenAccelerationChart] = useState<{
    options: ApexOptions;
    series: ChartSeries[];
  }>({
    series: [
      {
        name: "breach count",
        data: []
      }
    ],
    options: {
      legend: {
        show: true,
        position: "top",
        horizontalAlign: "right",
        customLegendItems: ["High", "Medium", "Low"],
        markers: {
          fillColors: ["#ff0000", "#FF9F0A", "#349C42"],
          shape: "line",
          size: 10,
          strokeWidth: 3
        },
        labels: {
          colors: "#808080" // ✅ gray text for High / Medium / Low
        }
      },

      colors: [],
      chart: {
        type: "bar",
        height: 400,
        toolbar: {show: false}
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          borderRadius: 5,
          borderRadiusApplication: "end"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          1743465600000, 1746057600000, 1748736000000, 1751328000000,
          1754006400000, 1756684800000, 1759276800000, 1761955200000,
          1764547200000, 1767225600000, 1769904000000, 1772323200000
        ]
      },
      yaxis: {
        title: {
          text: "Breach count",
          style: {
            fontWeight: 500,
            fontSize: "12px",
            fontFamily: "Inter, sans-serif"
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val: number) {
            return val + "count";
          }
        }
      }
    }
  });

  useEffect(() => {
    let breachval: any = [];
    let dateval: any = [];
    if (valuesSuddenAcc.length > 0) {
      breachval = valuesSuddenAcc.map(val => val.breachCount);
    }
    if (valuesSuddenAcc.length > 0) {
      dateval = valuesSuddenAcc.map(val => new Date(val.date).getDate());
    }
    let colors = valuesSuddenAcc.map(val => {
      if (val.breachCount <= 100) return "#349C42";
      if (val.breachCount <= 200) return "#FF9F0A";
      return "#FC2A3D";
    });
    setSuddenAccelerationChart(prev => ({
      ...prev,
      series: [{name: "breach count", data: breachval}],
      options: {
        ...prev.options,
        plotOptions: {
          ...prev.options.plotOptions,
          bar: {
            ...prev.options.plotOptions?.bar,
            distributed: true
          }
        },
        colors,
        xaxis: {
          ...prev.options.xaxis,
          categories: dateval
        }
      }
    }));
  }, [valuesSuddenAcc]);
  return (
    <div>
      <Chart
        options={suddenAccelerationChart.options}
        series={suddenAccelerationChart.series}
        type="bar"
        height={150}
      />
    </div>
  );
}
